/**
 * @desc        AWS Actions
 * @version     1.0.1 (Logout no longer resets language) - 26 Mar 2026
 */

import { ENVPRE } from 'app-config/index.js'
import * as authService from 'auth/aws.js'
import { localeToi18next } from 'helpers/language-code-formatter.js'
import i18n from 'international/i18n.js'
import * as FirebaseDb from 'services/firebase/firebaseDb.js'
import * as actionTypes from '../action-types.js'

export const awsRefreshToken = payload => {
    return async (dispatch, getState) => {
        const aws = getState().aws

        if (aws && aws.loading) {
            dispatch({
                type: actionTypes.AWS_USER_REQUEST_CACHE,
            })
            return null
        }

        const iat = aws && aws.data && aws.data.signInUserSession && aws.data.signInUserSession.idToken && aws.data.signInUserSession.idToken.payload ? aws.data.signInUserSession.idToken.payload.iat : null
        const exp = aws && aws.data && aws.data.signInUserSession && aws.data.signInUserSession.idToken && aws.data.signInUserSession.idToken.payload ? aws.data.signInUserSession.idToken.payload.exp : null
        const expiresIn = exp - iat
        const timeNow = new Date().getTime()
        if ((!payload || !payload.force) && iat && exp && expiresIn && (exp - expiresIn / 2) * 1000 > timeNow) {
            dispatch({
                type: actionTypes.AWS_USER_REQUEST_CACHE,
            })
            return null
        }

        // do aws refresh here
        dispatch({
            type: actionTypes.AWS_USER_REQUEST,
        })
        try {
            let session = await authService.awsRefresh()

            if (session && session.code) {
                throw session
            }

            if (session?.attributes?.['custom:prefLanguage']) {
                i18n.changeLanguage(localeToi18next(session.attributes['custom:prefLanguage']))
                localStorage.setItem(`${ENVPRE}lng`, localeToi18next(session.attributes['custom:prefLanguage']))
            } else {
                i18n.changeLanguage('en')
                localStorage.removeItem(`${ENVPRE}lng`)
            }

            if (session && session.signInUserSession && session.signInUserSession.idToken && session.signInUserSession.idToken.payload && session.signInUserSession.idToken.payload.oxfdt) {
                const accounts = session.signInUserSession.idToken.payload.oxfdt.split(',')
                localStorage.setItem(`${ENVPRE}accounts`, JSON.stringify(accounts))
            }
            if (session && session.signInUserSession && session.signInUserSession.accessToken && session.signInUserSession.accessToken.payload) {
                const clientId = session.signInUserSession.accessToken.payload.client_id
                const lastAuthUser = localStorage.getItem(`CognitoIdentityServiceProvider.${clientId}.LastAuthUser`)
                localStorage.setItem('cidlau', `${clientId}.${lastAuthUser}`)
            }
            dispatch({
                type: actionTypes.AWS_USER_REQUEST_REFRESH_SUCCESS,
                data: session,
            })
            try {
                let fbSignedIn = await FirebaseDb.signIn()
                // disabling push notifications for the time being
                // if (Capacitor.getPlatform() === 'web') {
                //     await FirebasePushWeb.saveDeviceToken()
                // } else {
                //     await FirebasePushMobile.saveDeviceToken()
                // }
                dispatch({
                    type: actionTypes.FD_NOTIFICATIONS_SIGNIN,
                    signedIn: fbSignedIn,
                })
            } catch (err) {
                console.error(err)
                dispatch({
                    type: actionTypes.FD_NOTIFICATIONS_SIGNIN_FAIL,
                })
            }
            return null
        } catch (err) {
            console.error(err)
            dispatch({
                type: actionTypes.AWS_USER_REQUEST_REFRESH_FAILURE,
                error: err,
            })
            dispatch({
                type: actionTypes.FD_NOTIFICATIONS_SIGNIN_FAIL,
            })
            return null
        }
    }
}

export const awsLogin = (payload, tenant) => {
    return async (dispatch, getState) => {
        dispatch({
            type: actionTypes.AWS_USER_REQUEST,
        })
        try {
            const data = await authService.awsLogin({
                data: {
                    email: payload.email,
                    password: payload.password,
                },
            })
            if (data && data.code) throw data

            // probable dont need to do this here yet, or at all. resetting farmden to en-au

            if (data?.attributes?.['custom:prefLanguage']) {
                i18n.changeLanguage(localeToi18next(data.attributes['custom:prefLanguage']))
                localStorage.setItem(`${ENVPRE}lng`, localeToi18next(data.attributes['custom:prefLanguage']))
            } else {
                i18n.changeLanguage('en')
                localStorage.removeItem(`${ENVPRE}lng`)
            }

            if (data?.signInUserSession?.idToken?.payload?.oxfdt) {
                const accounts = data.signInUserSession.idToken.payload.oxfdt.split(',')

                let i = 0
                if (payload.preferredId) {
                    i = accounts.indexOf(payload.preferredId)
                    if (i < 0) i = 0
                }

                localStorage.setItem(`${ENVPRE}accounts`, JSON.stringify(accounts))
                localStorage.setItem(`${ENVPRE}account`, accounts[i])
            }

            if (data?.signInUserSession?.accessToken?.payload) {
                const clientId = data.signInUserSession.accessToken.payload.client_id
                const lastAuthUser = localStorage.getItem(`CognitoIdentityServiceProvider.${clientId}.LastAuthUser`)
                localStorage.setItem('cidlau', `${clientId}.${lastAuthUser}`)
                //after all persistence to loccal stroage is finished call the firebase calls
            }
            dispatch({
                type: actionTypes.AWS_USER_REQUEST_SUCCESS,
                data,
            })
            try {
                let fbSignedIn = await FirebaseDb.signIn()
                // if (Capacitor.getPlatform() === 'web') {
                //     await FirebasePushWeb.saveDeviceToken()
                // } else {
                //     await FirebasePushMobile.saveDeviceToken()
                // }
                dispatch({
                    type: actionTypes.FD_NOTIFICATIONS_SIGNIN,
                    signedIn: fbSignedIn,
                })
            } catch (err) {
                console.error(err)
                dispatch({
                    type: actionTypes.FD_NOTIFICATIONS_SIGNIN_FAIL,
                })
            }
        } catch (err) {
            console.error(err)
            dispatch({
                type: actionTypes.AWS_USER_REQUEST_FAILURE,
                error: err,
            })
        }
    }
}

export const awsLogout = payload => {
    return async (dispatch, getState) => {
        try {
            // if (getState()?.aws?.data?.signInUserSession?.idToken) {
            //     if (Capacitor.getPlatform() === 'web') {
            //         await FirebasePushWeb.deleteDeviceToken()
            //     } else {
            //         await FirebasePushMobile.deleteDeviceToken()
            //     }
            // }
            await FirebaseDb.signOut()
            await authService.awsLogout()
        } catch (err) {
            console.error(err)
        }

        const languageBeforeLogout = i18n.language || 'en'

        const allLocalStorage = localStorage
        /* eslint  array-callback-return: 0 */
        Object.keys(allLocalStorage).map(key => {
            if (key.indexOf('lng') >= 0 || key.indexOf('CognitoIdentityServiceProvider') >= 0 || key.indexOf('at.') === 0 || key.indexOf('it.') === 0 || key === 'accounts' || key === 'cidlau') {
                localStorage.removeItem(key)
            }
        })

        // Keep the UI language after logout (e.g. logout page copy) instead of forcing English; also re-persists i18n storage keys cleared above
        i18n.changeLanguage(languageBeforeLogout)

        dispatch({
            type: actionTypes.AWS_USER_REQUEST_CLEAR,
        })
    }
}

export const awsUpdate = (payload, tenant) => {
    return async (dispatch, getState) => {
        dispatch({
            type: actionTypes.AWS_USER_UPDATE,
        })

        let adjustedPayload = { ...payload }
        if (payload?.['custom:prefLanguage'] && window.location.href.includes('fmd-farmdenpark') && tenant === 'fmd-farmdenpark') {
            adjustedPayload = {
                ...payload,
                'custom:prefLanguage': 'en-au',
            }
        }

        try {
            const data = await authService.awsUpdateUserAttributes(adjustedPayload)
            if (data && data.code) throw data

            if (payload?.['custom:prefLanguage']) {
                i18n.changeLanguage(localeToi18next(payload['custom:prefLanguage']))
                localStorage.setItem(`${ENVPRE}lng`, localeToi18next(payload['custom:prefLanguage']))
            }

            dispatch({
                type: actionTypes.AWS_USER_UPDATE_SUCCESS,
                data: payload,
            })
            return { data, lng: localeToi18next(payload['custom:prefLanguage']) }
        } catch (err) {
            dispatch({
                type: actionTypes.AWS_USER_UPDATE_FAILURE,
                error: err,
            })
            throw err
        }
    }
}
